
import SelectInput from '@marketplace/components/forms/inputs/select-input.vue'
import { trackHeaderClick } from '@marketplace/helpers/segment/index.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'
import { LANGUAGES_IN_PICKER } from '@shared/config/lang.js'
import cloneDeep from 'lodash/cloneDeep'

export default {
    name: 'LanguageCurrencyPicker',

    components: {
        SelectInput,
    },

    data() {
        return {
            isSubmitting: false,
            activeLanguage: '',
        }
    },

    computed: {
        langs() {
            return LANGUAGES_IN_PICKER || []
        },
        displayedLangs() {
            const langs = cloneDeep(this.langs)
            return langs.map((lang) => {
                return {
                    ...lang,
                    label: `${lang.label} - ${lang.locale.toUpperCase()}`,
                    value: lang.locale,
                }
            })
        },
    },

    mounted() {
        EventBus.$on('save-language-form', this.updatePreferences)
    },

    beforeDestroy() {
        EventBus.$off('save-language-form')
    },

    beforeMount() {
        const activeLocale = this.langs.find(
            (lang) => lang.locale === this.$locale
        )
        this.activeLanguage = activeLocale.locale
    },

    methods: {
        async updatePreferences() {
            this.isSubmitting = true

            this.changeLanguage(this.activeLanguage)
            this.closeModal()
        },

        changeLanguage(lang) {
            const { origin, pathname, search } = window.location
            const regex = /\/([a-z]){2}\//
            const isNotHomepage = regex.test(pathname)
            const pathToReplace = isNotHomepage
                ? `/${this.$locale}/`
                : `/${this.$locale}`
            const pathWithoutLocale =
                this.$locale === 'en'
                    ? pathname
                    : pathname.replace(pathToReplace, '')

            trackHeaderClick({ name: `Language ${lang}` })
            this.$helpers.triggerReloadSpinner(
                `${origin}/locale/${lang}?return=${pathWithoutLocale}${search}`
            )
        },

        closeModal() {
            EventBus.$emit('modal-close')
        },
    },
}
